export default "/images/9df8885395d34c9a8dca3b3f370e29a8.avif";